import React, { useMemo } from 'react';

const formatCurrency = (value) => {
  if (value == null || value === '') return '$0';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingDealMetrics = ({ deals }) => {
  const metrics = useMemo(() => {
    const activeStages = new Set([
      'Prospect', 'Qualified', 'Preparing', 'Submitted', 'Under Review',
      'Approved', 'Contract Sent', 'Clawback Risk',
    ]);
    const active = deals.filter((deal) => activeStages.has(deal.stage));
    const funded = deals.filter((deal) => deal.stage === 'Funded');
    const clawback = deals.filter((deal) => ['Low', 'Medium', 'High'].includes(deal.clawbackRisk) && activeStages.has(deal.stage));

    const sum = (items, key) => items.reduce((total, item) => total + (Number(item[key]) || 0), 0);

    return [
      { label: 'Active deals', value: String(active.length) },
      { label: 'Total requested', value: formatCurrency(sum(deals, 'requestedAmount')) },
      { label: 'Total approved', value: formatCurrency(sum(deals, 'approvedAmount')) },
      { label: 'Total funded', value: formatCurrency(sum(funded, 'fundedAmount')) },
      { label: 'Projected commissions', value: formatCurrency(sum(deals, 'expectedCommission')) },
      { label: 'Earned commissions', value: formatCurrency(sum(funded, 'expectedCommission')) },
      { label: 'Clawback risk', value: String(clawback.length) },
    ];
  }, [deals]);

  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {metrics.map((metric) => (
        <div key={metric.label} className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
          <div className="text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">{metric.label}</div>
          <div className="mt-1 text-lg font-bold text-[var(--fg-text)]">{metric.value}</div>
        </div>
      ))}
    </div>
  );
};

export default FundingDealMetrics;
